<mat-accordion>
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>Selector tenant</mat-panel-title>
    </mat-expansion-panel-header>

    <!-- Buscador -->
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Selecciona tenant id</mat-label>
      <input matInput [(ngModel)]="appService.tenantId" (change)="tenantAsOnChange($event)" placeholder="Escribe el numero de tenant">
      <mat-icon matSuffix>add_business</mat-icon>
    </mat-form-field>
  </mat-expansion-panel>
</mat-accordion>